import React, { createContext, useContext, useMemo, useState } from "react";

const RegistryContext = createContext(null);

export const RegistryProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [registry, setRegistry] = useState([]); // wishlist items: [{ item }]
  const [careFund, setCareFund] = useState([]); // [{ giver, amount, message, at }]
  const [view, setView] = useState("mother"); // "mother" | "guest"

  const addItem = (item) => {
    setRegistry((prev) =>
      prev.find((r) => r.item.id === item.id) ? prev : [...prev, { item }]
    );
  };
  const removeItem = (id) =>
    setRegistry((prev) => prev.filter((r) => r.item.id !== id));

  const contributeToFund = (amount, giver = "A dear friend", message = "") => {
    const clean = Math.max(0, Math.round(Number(amount) || 0));
    if (clean <= 0) return;
    setCareFund((prev) => [
      ...prev,
      {
        giver: (giver || "A dear friend").trim() || "A dear friend",
        amount: clean,
        message: (message || "").trim(),
        at: new Date().toISOString(),
      },
    ]);
  };

  const value = useMemo(
    () => ({
      profile,
      setProfile,
      registry,
      addItem,
      removeItem,
      isInRegistry: (id) => registry.some((r) => r.item.id === id),
      view,
      setView,
      careFund,
      contributeToFund,
      totalRaised: careFund.reduce((s, c) => s + c.amount, 0),
      givers: careFund,
    }),
    [profile, registry, view, careFund]
  );

  return <RegistryContext.Provider value={value}>{children}</RegistryContext.Provider>;
};

export const useRegistry = () => {
  const ctx = useContext(RegistryContext);
  if (!ctx) throw new Error("useRegistry must be used within RegistryProvider");
  return ctx;
};
